import { render, staticRenderFns } from "./EditEventAutomation.vue?vue&type=template&id=61d4fb54&scoped=true"
import script from "./EditEventAutomation.vue?vue&type=script&lang=js"
export * from "./EditEventAutomation.vue?vue&type=script&lang=js"
import style0 from "./EditEventAutomation.vue?vue&type=style&index=0&id=61d4fb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4fb54",
  null
  
)

export default component.exports